export const download = (href: string, fileName: string) => {
  const tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = href;
  tempLink.setAttribute('download', fileName);

  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank');
  }

  document.body.appendChild(tempLink);
  tempLink.click();

  setTimeout(() => {
    document.body.removeChild(tempLink);
  }, 200);
};

export const blobToObjectURL = (blob: Blob) => {
  return URL.createObjectURL(blob);
};

export const createCsv = (data: object[]) => {
  const titleKeys = Object.keys(data[0] ?? {});

  const refinedData = [];
  refinedData.push(titleKeys);

  data.forEach((item) => {
    refinedData.push(Object.values(item));
  });

  let csvContent = '';

  refinedData.forEach((row) => {
    csvContent += row.join(',') + '\n';
  });

  return new Blob([csvContent], { type: 'text/csv;charset=utf-8,' });
};
